export const data = {
    effectiveDate: "07-09-2023",
    lastUpdated: "07-09-2023",
    name: "JQBase",
    website: "https://jqbase.com",
    // dataCollected: ["0.1. Email address","0.2. First name and last name","0.3. Phone number","0.4. Address, Country, State, Province, ZIP/Postal code, City","0.5. Cookies and Usage Data"],
    dataCollected: ["0.1. Email address","0.2. Phone Number","0.3. User Name"],
    email: "jqbase.com@gmail.com",
    phone: "+959795539454"
}